import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const PALETTE_STATUSES = {
   READY_TO_RENT: 'READY_TO_RENT',
   DAMAGED: 'DAMAGED',
   LOST: 'LOST',
} as const;

export const usePaletteStatuses = () => {
   const { t } = useTranslation();

   const PALETTE_STATUSES_LABELS = useMemo(
      () => ({
         READY_TO_RENT: t('storage.external.table.ready'),
         DAMAGED: t('edit_pallets.table.damaged'),
         LOST: t('storage.internal.table.lost'),
      }),
      [t],
   );

   const PALETTE_STATUSES_OPTIONS = useMemo(
      () => [
         {
            value: PALETTE_STATUSES.READY_TO_RENT,
            label: PALETTE_STATUSES_LABELS.READY_TO_RENT,
         },
         {
            value: PALETTE_STATUSES.LOST,
            label: PALETTE_STATUSES_LABELS.LOST,
         },
         {
            value: PALETTE_STATUSES.DAMAGED,
            label: PALETTE_STATUSES_LABELS.DAMAGED,
         },
      ],
      [PALETTE_STATUSES_LABELS],
   );

   return {
      PALETTE_STATUSES,
      PALETTE_STATUSES_LABELS,
      PALETTE_STATUSES_OPTIONS,
   };
};
